import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchCreditTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields=['id', 'cid', 'name'], id } = params;
  const dropdown_type = 'credit_type/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function saveCreditType(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  const creditTypeData = {
    doc_type: DocType.CREDIT_TYPE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    system_defined: util.toBoolean(data.system_defined)
  };

  return common.saveDoc(app, {
    source: data,
    doc: creditTypeData,
    user,
  });
}

export function deleteCreditType(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.CREDIT_TYPE
  });
}

export function fetchCreditTypeById(app, params) {
  const { id } = params;
  const docType = DocType.CREDIT_TYPE;
  return common.getDoc(app, { id, docType });
}
